import { api } from "@/builders/axios";
import { FilterParams } from "@/builders/types/filter-params";
import { content } from "./content";
import { id } from "./id";

const get = function (params?: FilterParams) {
  return api.get<{
    count: number;
    next: string;
    previous: string;
    results: Array<{
      module: number;
      assessment: number;
    }>;
  }>("courses/module/chapter", {
    params,
  });
};

const post = function (data: { module: number; assessment: number }) {
  return api.post("courses/module/chapter", data);
};

export const chapter = {
  get,
  post,
  id,
  content,
};
